export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = error.message;
  return (
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("Importing a module script failed") ||
    msg.includes("error loading dynamically imported module")
  );
}

export async function isStaleDeployment(): Promise<boolean> {
  try {
    const res = await fetch("/api/version", { cache: "no-store" });
    if (!res.ok) return false;
    const data = (await res.json()) as { version: string };
    const clientVersion = window.__BLIS_CONFIG__?.version;
    if (!clientVersion) return false;
    return data.version !== clientVersion;
  } catch {
    return false;
  }
}
